module.exports = __webpack_public_path__ + "img/crystal-gold-logo.59d37edf.jpg";